import DocumentType from "./DocumentType";
import { formatDate } from "../utils/format-utils";

export default class FlattenedClientChartVM {
  clientId?: number | null;
  clientName?: string | null;
  providerId?: number | null;
  providerName?: string | null;
  fileId?: number | null;
  fileName?: string | null;
  fileExtension?: string | null;
  service?: string | null;
  serviceCoordinationNoteId?: number | null;
  dateOfService?: Date | null;
  startTime?: Date | null;
  scSignatureId?: number | null;
  sessionNoteId?: number | null;
  supervisorId?: number | null;
  supervisorSignatureId?: number | null;
  gapInServiceId?: number | null;
  sentToServiceCoordinator?: boolean | null;
  gapDate?: Date | null;
  inPersonLogId?: number | null;
  payPeriodStart?: Date | null;
  payPeriodEnd?: Date | null;
  reportAssignmentFileId?: number | null;
  reportTypeName?: string | null;
  dueDate?: Date | null;
  programId?: number | null;
  assessemntId?: number | null;
  assessmentDate?: Date | null;
  evaluationDocumentId?: number | null;
  documentName?: string | null;
  description?: string | null;
  dateReceived?: Date | null;
  uploadedAt?: Date | null;
  documentType?: DocumentType | null;
  planId?: number | null;

  public constructor(
    params: FlattenedClientChartVM = {} as FlattenedClientChartVM
  ) {
    let {
      clientId = 0,
      clientName = "",
      providerId = null,
      providerName = "",
      fileId = null,
      fileName = "",
      fileExtension = "",
      service = "",
      serviceCoordinationNoteId = null,
      dateOfService = null,
      startTime = null,
      scSignatureId = null,
      sessionNoteId = null,
      supervisorId = null,
      supervisorSignatureId = null,
      gapInServiceId = null,
      sentToServiceCoordinator = null,
      gapDate = null,
      inPersonLogId = null,
      payPeriodStart = null,
      payPeriodEnd = null,
      reportAssignmentFileId = null,
      reportTypeName = null,
      dueDate = null,
      programId = null,
      assessemntId = null,
      assessmentDate = null,
      evaluationDocumentId = null,
      documentName = null,
      description = null,
      dateReceived = null,
      uploadedAt = null,
      documentType = null,
      planId = null,
    } = params;
    this.clientId = clientId;
    this.clientName = clientName;
    this.providerId = providerId;
    this.providerName = providerName;
    this.fileId = fileId;
    this.fileName = fileName;
    this.fileExtension = fileExtension;
    this.service = service;
    this.serviceCoordinationNoteId = serviceCoordinationNoteId;
    this.dateOfService = dateOfService;
    this.startTime = startTime;
    this.scSignatureId = scSignatureId;
    this.sessionNoteId = sessionNoteId;
    this.supervisorId = supervisorId;
    this.supervisorSignatureId = supervisorSignatureId;
    this.gapInServiceId = gapInServiceId;
    this.sentToServiceCoordinator = sentToServiceCoordinator;
    this.gapDate = gapDate;
    this.inPersonLogId = inPersonLogId;
    this.payPeriodStart = payPeriodStart;
    this.payPeriodEnd = payPeriodEnd;
    this.reportAssignmentFileId = reportAssignmentFileId;
    this.reportTypeName = reportTypeName;
    this.dueDate = dueDate;
    this.programId = programId;
    this.assessemntId = assessemntId;
    this.assessmentDate = assessmentDate;
    this.evaluationDocumentId = evaluationDocumentId;
    this.documentName = documentName;
    this.description = description;
    this.dateReceived = dateReceived;
    this.uploadedAt = uploadedAt;
    this.documentType = documentType && new DocumentType(documentType);
    this.planId = planId;
  }
  get formattedDateOfService() {
    return formatDate(this.dateOfService);
  }
  get formattedDueDate() {
    return formatDate(this.dueDate);
  }
  get formattedPayPeriodStart() {
    return formatDate(this.payPeriodStart);
  }
  get formattedPayPeriodEnd() {
    return formatDate(this.payPeriodEnd);
  }
  get formattedDateReceived() {
    return formatDate(this.dateReceived);
  }
  get formattedAssessmentDate() {
    return formatDate(this.assessmentDate);
  }
  get formattedGapDate() {
    return formatDate(this.gapDate);
  }
  get formattedUploadedAt() {
    return formatDate(this.uploadedAt);
  }
  get requiresSupervisorSignature() {
    return this.supervisorId != null;
  }
  get documentTypeName() {
    return this.documentType && this.documentType.name;
  }
  get key() {
    return this.fileId;
  }
}
